import StatusPills from "../../StatusPills";
import { FileStatusType } from "../../../types/fileStatusType";
import { Text } from "../../Type";

const StatusTextCell = ({ value }: { value: FileStatusType }) => {
  if (!value) return <Text>-</Text>;
  return <StatusPills status={value} />;
};


export default StatusTextCell;
